module.exports = __webpack_public_path__ + "img/xzIco (4).3e465304.png";